import React from 'react';
import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    makeStyles,
    Typography,
    Paper,
    IconButton,
    TextField,
    Grid
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { FormattedMessage } from 'react-intl';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import useRouter from 'utils/useRouter';

const useStyles = makeStyles(theme => ({
    container: {
        marginBottom: theme.spacing(2),
        position: 'relative'
    },
    title: {
        fontSize: 25,
        color: '#030F40',
        fontWeight: 'bold',
        lineHeight: '40px'
    },
    subtitle: {
        color: '#6E7697'
    },
    root: {
        padding: '0px 8px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: 420,
        margin: theme.spacing(1, 2),
        backgroundColor: 'white',
        borderRadius: 50,
        boxShadow: 'none',
        border: '1px solid #D3DAF6',
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        color: 'black'
    },
    iconButton: {
        padding: `6px 10px`,
        color: '#BAC8BF',
        paddingRight: 0
    },
    innerinput: {
        color: 'black',
        '&::placeholder': {
            color: '#BAC8BF'
        }
    },
    backBtn: {
        padding: 7,
        '&:hover': {
            backgroundColor: 'transparent !important'
        }
    }
}));

const Header = ({ title, hideSubtitle, searchPlaceholder, className, keyword, setKeyword }) => {
    const classes = useStyles();
    const router = useRouter();
    return (
        <div className={clsx(classes.container, className)}>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm>
                    {
                        !hideSubtitle ?
                            <div>
                                <Grid container alignItems='flex-start'>
                                    <IconButton onClick={() => router.history.push("/catalogue")} className={classes.backBtn}><ArrowBackIosIcon /></IconButton>&nbsp;
                                    <div>
                                        <Typography className={classes.title}>{title ? title : <FormattedMessage id="applications.title" />}</Typography>
                                        <Typography className={classes.subtitle}><FormattedMessage id="applications.subtitle" /></Typography>
                                    </div>
                                </Grid>
                            </div> :
                            <div />
                    }
                </Grid>
                <Grid item xs={12} sm="auto">
                    <Paper component="form" className={classes.root} style={{ width: '100%' }}>
                        <IconButton className={classes.iconButton} aria-label="menu">
                            <SearchIcon />
                        </IconButton>
                        <TextField
                            className={classes.input}
                            placeholder={searchPlaceholder || "Rechercher une solution"}
                            inputProps={{ 'aria-label': 'search' }}
                            InputProps={{
                                disableUnderline: true,
                                classes: { input: classes.innerinput }
                            }}
                            value={keyword}
                            onChange={e => {
                                e.persist()
                                setKeyword(e.target.value)
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
};

Header.propTypes = {
    className: PropTypes.any,
    title: PropTypes.string,
    hideSubtitle: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
    keyword: PropTypes.string,
    setKeyword: PropTypes.func
};

Header.defaultProps = {
    className: null,
};

export default Header;
